<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Hood 2 Good</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li><li id="toc-li-5"><a href="#/text/ch005#chapter-1-the-dig">Chapter 1 The Dig</a></li><li id="toc-li-6"><span href="#/text/ch006#chapter-2-payback" title="Link target outside of Sample">Chapter 2 Payback</span></li><li id="toc-li-7"><span href="#/text/ch007#chapter-3-smoking" title="Link target outside of Sample">Chapter 3 Smoking</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-4-christians" title="Link target outside of Sample">Chapter 4 Christians</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-5-betrayal" title="Link target outside of Sample">Chapter 5 Betrayal</span></li><li id="toc-li-10"><span href="#/text/ch010#chapter-6-thinking-ahead" title="Link target outside of Sample">Chapter 6 Thinking Ahead</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?32e0b7ec